/* @flow */

import React from 'react';

import List from '@material-ui/core/List';

import ConfirmingAddSupplierTabContactListItemComponent from './item';

import CompanyContactPerson from 'models/companies/companyContactPerson';

type ConfirmingAddSupplierTabContactListComponentProps = {
  selectedContactPerson: CompanyContactPerson;
  contactPersons: CompanyContactPerson[];
  selectHandler: (contactPersonId: number) => void;
  unselectHandler: (contactPersonId: number) => void;
};

export default function ConfirmingAddSupplierTabContactListComponent(props: ConfirmingAddSupplierTabContactListComponentProps) {
  if (!props.contactPersons) {
    return null;
  }

  return (
    <List>
      {props.contactPersons.map(contactPerson => (
        <ConfirmingAddSupplierTabContactListItemComponent
          key={`contact-${contactPerson.id}`}
          contactPerson={contactPerson}
          selected={props.selectedContactPerson?.id === contactPerson.id}
          selectHandler={props.selectHandler}
          unselectHandler={props.unselectHandler}
        />
      ))}
    </List>
  );
}
